import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export interface SendSMSPayload {
  contact: string;
  message: string;
}

export const SendSMS = async (payload: SendSMSPayload): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/sms/send`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to send SMS.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
